<template>
    <div v-if="banner" class="dml-mega-menu-tile-wrapper"
         :data-tracking-click="banner.tracking">
        <a :href="banner.url" class="dml-mega-menu-tile"
           :title="banner.title"
           data-ga="mega_menu.click_menu_banner">
            <img :data-src="banner.smallImageUrl"
                 src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                 width="284"
                 height="264"
                 :data-srcset="banner.largeImageUrl"
                 :alt="banner.alt"
                 class="dml-mega-menu-tile__image lazy"/>
            <div class="dml-mega-menu-tile__desc">
                <p>{{ banner.text }}</p>
                <span class="dml-mega-menu-tile__arrow">
                        Sprawdź
                        <svg width="12" height="12">
                            <use
                                :xlink:href="`/assets/symbols/icons.svg?v=${iconsSetVersion}#im-angle-right`"></use>
                        </svg>
                    </span>
            </div>
        </a>
    </div>
</template>
<script>

export default {
    name: 'dm-mega-menu-banner',
    props: {
        banner: {
            type: Object
        },
        iconsSetVersion: String
    }
};
</script>

